// extracted by mini-css-extract-plugin
module.exports = {"mobileBreadcrumbs":"breadcrumbs_mobileBreadcrumbs__1B5zo"};